var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEmptyPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9C10 7.34315 11.2536 6 12.8 6H35.2C36.7464 6 38 7.34315 38 9V39C38 40.6569 36.7464 42 35.2 42H12.8C11.2536 42 10 40.6569 10 39V9Z",
    stroke: "#FF646C",
    strokeWidth: 2,
    strokeMiterlimit: 16,
    strokeDasharray: "4 2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5146,
    y: 18.8281,
    width: 4,
    height: 20,
    rx: 2,
    transform: "rotate(-45 15.5146 18.8281)",
    fill: "#FF646C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 20,
    rx: 2,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 32.4854 18.8281)",
    fill: "#FF646C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyPage);
export default __webpack_public_path__ + "static/media/ic_empty_page.214eb74e.svg";
export { ForwardRef as ReactComponent };